<template>
  <label
    :class="{ 'flex-row': !column, 'flex-column': column }"
    @click="toggleState"
    class="d-flex align-items-center mb-0"
  >
    <div class="toggler flex-shrink-0">
      <input
        :name="fieldName"
        :class="{ 'active-toggler': isActive }"
        :value="isActive ? 1 : 0"
        type="hidden"
      />
      <span class="toggler-slider">
        <span class="toggler-slider-knob"></span>
      </span>
    </div>
    <div :class="{ 'ml-3': !column, 'mt-1': column }" class="label font-weight-bold text-muted">
      {{ isActive ? activeText : inactiveText }}
    </div>
  </label>
</template>
<script>
export default {
  name: "Toggler",
  props: {
    column: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      required: true,
    },
    activeText: {
      type: String,
      required: true,
    },
    inactiveText: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    confirmChangeText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
  computed: {
    confirmChange() {
      return !!this.confirmChangeText && !this.isActive;
    },
  },
  methods: {
    toggleState() {
      if (this.confirmChange) {
        this.toggleActiveConfirm();
      } else {
        this.toggleActive();
      }
    },
    toggleActiveConfirm() {
      if (confirm(this.confirmChangeText)) {
        this.toggleActive();
      }
    },
    toggleActive() {
      this.isActive = !this.isActive;
      this.$emit("onSetActive");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

$toggler-height: 26px;
$toggler-width: 60px;
$toggler-padding: 4px;

.label {
  transition: opacity $transition-duration;
}

.toggler {
  display: inline-block;
  height: $toggler-height + $toggler-padding * 2;
  position: relative;
  width: $toggler-width;

  input {
    height: 0;
    opacity: 0;
    width: 0;
  }
}

.toggler-slider {
  background-color: $gray-400;
  border-radius: $toggler-height + $toggler-padding * 2;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: $toggler-width;
  transition: $transition-duration;
}

.toggler-slider-knob {
  display: block;
  position: absolute;
  top: 100%;
  transition: transform $transition-duration-short;

  &::before,
  &::after {
    border-radius: 50%;
    bottom: $toggler-padding;
    content: "";
    height: $toggler-height;
    left: $toggler-padding;
    position: absolute;
    transition: $transition-duration;
    width: $toggler-height;
  }

  &::before {
    background-color: $white;
  }
}

input.active-toggler + .toggler-slider {
  background-color: $success;
}

input:focus + .toggler-slider {
  box-shadow: 0 0 1px $success;
}

input.active-toggler + .toggler-slider .toggler-slider-knob {
  transform: translateX($toggler-height);
}
</style>
